import {
  BlogPostsState,
  BlogPostsAction,
  BlogPostsActionType,
} from "../../types/blog/blogPostsTypes";
import { ProcessingStatusType } from "../../types/nlsTypes";

export const initialBlogPostsState: BlogPostsState = {
  blogPosts: [],
  blogPostsStatus: ProcessingStatusType.pending,
  //filteredBlogPosts: [],
};

export const blogPostsReducer = (
  blogPostsState: BlogPostsState, //: PyramidDetailsState,
  action: BlogPostsAction //: PyramidDetailsAction,
): BlogPostsState => {
  switch (action.type) {
    case BlogPostsActionType.BlogPostsFetchInit: //'BLOG_POSTS_FETCH_INIT':
      return {
        ...blogPostsState,
        blogPostsStatus: ProcessingStatusType.pending,
      };
    case BlogPostsActionType.BlogPostsFetchSuccess: //'CLUB_FETCH_SUCCESS':
      return {
        ...blogPostsState,
        blogPostsStatus: ProcessingStatusType.loaded,
        blogPosts: action.payload,
      };
    case BlogPostsActionType.FilteredBlogPosts:
      return {
        ...blogPostsState,
        //filteredBlogPosts: action.payload,
      };
    case BlogPostsActionType.BlogPostsAddPost:
      var newBlogPosts = [...blogPostsState.blogPosts!];
      //newBlogPosts.add(action.actionPayload!.blogPost!);
      return {
        ...blogPostsState,
        blogPosts: [
          ...blogPostsState.blogPosts!,
          action.actionPayload!.blogPost!,
        ],
      };
    case BlogPostsActionType.BlogPostUpdatePublished:
      let newBlogPostList = blogPostsState.blogPosts!.map((blogPost, index) => {
        if (blogPost.ID !== action.actionPayload?.blogPostId) {
          return blogPost;
        } else {
          return {
            ...blogPost,
            IsPublished: !blogPost.IsPublished,
          };
        }
      });
      return {
        ...blogPostsState,
        blogPosts: newBlogPostList,
      };
    default:
      return {
        ...blogPostsState,
      };
  }
};
